import type { SailState, ShipType } from './shipTemplates';

/**
 * The type each measured ship under sail is drawn as: the formed type whose hull length and main
 * masthead height, drawn at the painter scale through the painter camera, come nearest the
 * painted ones (docs/reference/ship-measure/berth-sizes.json). The painter gave R8 and R16 four
 * masts, one more than a ship of their size carries here; their size decides, as it decided the
 * painter scale (summary.json). The other painted ships draw their types by weight.
 */
export const PAINTED_TYPES: Readonly<Record<string, ShipType>> = {
  'berth-R3': 'kraeck',
  'berth-R8': 'bark',
  'berth-R16': 'hulk',
  'berth-R20': 'bark',
  'berth-R25': 'hulk',
  'berth-R26': 'hulk',
  'berth-R34': 'hulk',
};

/**
 * The sails a painted ship under sail spreads where it spreads fewer than all: R3 and R34 their
 * fore course alone, their main course furled along its yard or the mast bare, R16 its fore
 * course and lateen mizzen (docs/reference/ship-measure/harbour-count.json spread). Every other
 * berth under sail spreads all its sails.
 */
export const PAINTED_SAILS: Readonly<Record<string, SailState>> = {
  'berth-R3': 'fore',
  'berth-R16': 'foreAndMizzen',
  'berth-R34': 'fore',
};
